import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e4c90346")

_pushScopeId("data-v-e4c90346")
const _hoisted_1 = { class: "FileLoader__wrap" }
const _hoisted_2 = {
  key: 0,
  class: "FileLoader__area"
}
const _hoisted_3 = { class: "area__clip" }
const _hoisted_4 = {
  key: 1,
  class: "clip__flex"
}
const _hoisted_5 = { class: "clip__placeholder" }
const _hoisted_6 = {
  key: 1,
  class: "FileLoader__area"
}
const _hoisted_7 = {
  key: 0,
  class: "FileLoader__list"
}
const _hoisted_8 = { class: "item__name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_i_close = _resolveComponent("i-close")!
  const _component_i_clip = _resolveComponent("i-clip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", {
      class: ["FileLoader", { 'FileLoader--notempty': _ctx.value.length > 1, disabled: _ctx.disabled, isSmall: _ctx.isSmall, isInvalid: _ctx.isInvalid }],
      tabindex: "0"
    }, [
      _createVNode("input", {
        type: "file",
        hidden: "",
        disabled: _ctx.disabled,
        accept: _ctx.accept,
        multiple: _ctx.isMultiSelect,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
      }, null, 40, ["disabled", "accept", "multiple"]),
      (_ctx.isSmall)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_s_loader, { key: 0 }))
                : (_ctx.value.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createTextVNode(_toDisplayString(_ctx.loadedFileTitle) + " ", 1),
                      (!_ctx.disabled && _ctx.value.length > 0)
                        ? (_openBlock(), _createBlock(_component_i_close, {
                            key: 0,
                            class: "FileLoader__reset",
                            onClick: _withModifiers(_ctx.resetFiles, ["prevent"])
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_i_clip),
                      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.placeholder), 1)
                    ], 64))
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_s_loader, { key: 0 }))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
                ], 64))
          ]))
    ], 2),
    (_ctx.value.length > 1)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.value, (file, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "list__item",
              key: file
            }, [
              _createVNode("div", _hoisted_8, _toDisplayString(file.name), 1),
              (!_ctx.disabled)
                ? (_openBlock(), _createBlock(_component_i_close, {
                    key: 0,
                    class: "item__remove",
                    onClick: _withModifiers(($event: any) => (_ctx.removeFile(i)), ["prevent"])
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
})